// From https://chakra-ui.com/community/recipes/using-fonts

import { Global } from "@emotion/react";

const Fonts = ({ fontsPath = "/assets/fonts" }: { fontsPath?: string }) => (
  <Global
    styles={`
/* HelveticaNeue */

/* 200 = thin */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueThin.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueThinItalic.otf') format('opentype');
};

/* 300 = light */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueLight.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueLightItalic.otf') format('opentype');
};

/* 400 = regular */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueRoman.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueItalic.otf') format('opentype');
};

/* 700 = bold */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueBold.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueBoldItalic.otf') format('opentype');
};

/* 800 = heavy */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueHeavy.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueHeavyItalic.otf') format('opentype');
};

/* 900 = black */
@font-face {
  font-family: 'HelveticaNeue';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueBlack.otf') format('opentype');
};
@font-face {
  font-family: 'HelveticaNeue';
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: url('${fontsPath}/HelveticaNeueBlackItalic.otf') format('opentype');
};

/* Roboto */

/* 200 = Thin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Thin.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src: url('${fontsPath}/Roboto-ThinItalic.ttf') format('truetype');
}

/* 300 = Light */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Light.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url('${fontsPath}/Roboto-LightItalic.ttf') format('truetype');
}

/* 400 = Regular */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Regular.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Italic.ttf') format('truetype');
}

/* 600 = Medium */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Medium.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src: url('${fontsPath}/Roboto-MediumItalic.ttf') format('truetype');
}

/* 700 = Bold */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Bold.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url('${fontsPath}/Roboto-BoldItalic.ttf') format('truetype');
}

/* 800-900 = Heavy / Black */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 800 900;
  font-display: swap;
  src: url('${fontsPath}/Roboto-Black.ttf') format('truetype');
}

@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 800 900;
  font-display: swap;
  src: url('${fontsPath}/Roboto-BlackItalic.ttf') format('truetype');
}
    `}
  />
);

export default Fonts;
